export default "__VITE_ASSET__3c2ba432__"